// Ported from files/snapdraw-design-kit/code/src/lib/i18n/strings/dashboard.ts,
// trimmed to the keys the real (non-fixture) DashboardPage actually uses —
// the kit's dictionary carried several keys baked with fake numbers
// ("$96,400 awaiting signature") that our real, data-driven dashboard never
// renders. "3 Overdue" was one of those — now real (outstanding.overdue.*),
// singular/plural split the same way shell.trialBanner.* already is.
export const en = {
  "dashboard.breadcrumb": "Dashboard",
  "outstanding.label": "Outstanding",
  "outstanding.overdue.singular": "{count} Overdue",
  "outstanding.overdue.plural": "{count} Overdue",
  "filter.thisQuarter": "This Quarter",
  "filter.allProjects": "All Projects",
  "kpi.pending": "Pending",
  "kpi.accepted": "Accepted",
  "kpi.overdue": "Overdue",
  "kpi.closed": "Closed",
  "kpi.pending.note": "{amount} awaiting signature",
  "kpi.accepted.note": "{amount} in progress",
  "kpi.overdue.note": "{amount} past due date",
  "kpi.closed.note.quarter": "{amount} paid this quarter",
  "kpi.closed.note.allTime": "{amount} paid to date",
  "kpi.emptyNote": "Nothing yet",
  "docs.title": "Recent Documents",
  "docs.empty.title": "No documents yet",
  "docs.empty.body": "Quotes and pay applications you create will show up here with their status and amounts.",
  "docs.empty.cta": "New document",
  "cash.title": "Cash Timeline",
  "cash.empty.title": "No cash history",
  "cash.empty.body": "Once invoices start getting paid, your six-month cash timeline appears here.",
  "nextUp.title": "Next Up",
  "nextUp.empty": "Nothing scheduled. Deadlines and expiring quotes will land here.",
  "nextUp.more": "+{count} more due soon",
} as const;

export const es: Record<keyof typeof en, string> = {
  "dashboard.breadcrumb": "Panel",
  "outstanding.label": "Pendiente por cobrar",
  "outstanding.overdue.singular": "{count} vencido",
  "outstanding.overdue.plural": "{count} vencidos",
  "filter.thisQuarter": "Este trimestre",
  "filter.allProjects": "Todos los proyectos",
  "kpi.pending": "Pendiente",
  "kpi.accepted": "Aceptado",
  "kpi.overdue": "Vencido",
  "kpi.closed": "Cerrado",
  "kpi.pending.note": "{amount} esperando firma",
  "kpi.accepted.note": "{amount} en proceso",
  "kpi.overdue.note": "{amount} tras la fecha de vencimiento",
  "kpi.closed.note.quarter": "{amount} cobrado este trimestre",
  "kpi.closed.note.allTime": "{amount} cobrado en total",
  "kpi.emptyNote": "Nada aún",
  "docs.title": "Documentos recientes",
  "docs.empty.title": "Aún no hay documentos",
  "docs.empty.body": "Las cotizaciones y solicitudes de pago que crees aparecerán aquí con su estado y monto.",
  "docs.empty.cta": "Nuevo documento",
  "cash.title": "Línea de tiempo de flujo de caja",
  "cash.empty.title": "Sin historial de caja",
  "cash.empty.body": "En cuanto se paguen facturas, tu línea de tiempo de 6 meses aparecerá aquí.",
  "nextUp.title": "Próximamente",
  "nextUp.empty": "Nada programado. Los vencimientos y cotizaciones por expirar aparecerán aquí.",
  "nextUp.more": "+{count} más por vencer",
};
